module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/kimberly-figueroa-4e05c685a4d1dd091e51006b1401421a.jpg";